import React, { useContext, useState } from 'react';
import { Dialog, Pane, TickCircleIcon, Button, toaster } from 'evergreen-ui';
import Axios from 'axios';
import Serve from '../../../../app/serve';
import { useHistory } from 'react-router-dom';
import VendasContext from '../../../../context/VendasContext';
import Image from '../../../../images/Group_198.svg';
import Lottie from 'react-lottie';
import animationData from '../../../../images/Animations/lixeiraOK.json';

export default function DialogRemover({ recarregarVendas }) {
  const {
    isShowRemover,
    setIsShowRemover,
    processoIdRemove,
    itemAdicionado,
  } = useContext(VendasContext);

  const defaultOptions = {
    loop: false,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  };

  const history = useHistory();
  const usuario_id = localStorage.getItem('usuario_id');
  const token = localStorage.getItem('token');
  const app = Serve();
  const vendaRemover = itemAdicionado.filter(venda => venda.processo_id === processoIdRemove);
  const [loadingAnimation, setLoadingAnimation] = useState(false);

  async function removerVenda(close) {
    setLoadingAnimation(true)

    setTimeout(() => {
      close()
      setTimeout(() => {
        setLoadingAnimation(false);
      }, "200")
    }, "2500")

    await Axios.post(app + 'arquivar_adicionados', {
      "usuario_id": usuario_id,
      "processo_id": processoIdRemove,
    }, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }).then(res => {
      if (res.data.status && (res.data.status === 498 || res.data.status === 401)) {
        localStorage.clear();
        history.push('/');
      } else {
        toaster.notify('Você moveu a venda para a lixeira.')
        recarregarVendas('arquivados');
      }
    })
  };

  return (
    <Dialog
      isShown={isShowRemover}
      width={750}
      onCloseComplete={() => setIsShowRemover(false)}
      intent="danger"
      footer={
        loadingAnimation
          ? <div></div>
          :
          ({ close }) => (
            <Pane
              width={686}
              display="flex"
              alignItems="flex-end"
              justifyContent="space-between"
            >
              <Pane className='card'>
                <div className='cardTitle'>
                  {vendaRemover[0]?.bairro || ''} - {vendaRemover[0]?.uf || ''}
                  <TickCircleIcon color="green" />
                </div>
                <div className='cardText'>
                  {vendaRemover[0]?.logradouro || ''} - {vendaRemover[0]?.numero || ''}
                  {vendaRemover[0]?.complemento || ''}
                </div>
              </Pane>

              <Button appearance="primary" intent="danger" onClick={() => removerVenda(close)}>
                🗑 Mover para a lixeira
            </Button>
            </Pane>
          )
      }
    >
      {loadingAnimation
        ?
        <Lottie
          options={defaultOptions}
          height={150}
          width={150}
        />
        :
        <>
          <Pane
            display="flex"
            justifyContent="center"
            alignItems="center"
            marginTop={-5}
            marginBottom={47}
          >
            <img src={Image} alt="Group_153" />
          </Pane>

          <div className="dialog-content dialog-content-info">

            <h1 style={{ marginBottom: "17px", fontWeight: "600" }}>
              Você quer mesmo arquivar esta venda?
            </h1>
            <p className='dialogSubTitle'>
              A venda será movida para a lixeira, mas você poderá restaurá-la quando necessário.
            </p>
          </div>
        </>
      }
    </Dialog>
  )
};